import { showErrorNotification } from "@/utils/form-submission-notifications"
import { DefaultModal } from "@components/default-modal"
import { ModalProps } from "@mantine/core"
import { useQueryClient } from "@tanstack/react-query"
import {
  ActivityCalendarFormValues,
  ActivityCalendarForm,
} from "./ActivityCalendarForm"
import { useTranslation } from "react-i18next"
import {
  getGetApiWebCalendarGetProfilesQueryKey,
  getGetUpdateActivityCalendarProfileQueryKey,
  useGetUpdateActivityCalendarProfileSuspense,
  useUpdateActivityWebCalendarProfile,
} from "@/orval/gen"

function ModalContent({ onClose, profileId }: Props) {
  const queryClient = useQueryClient()
  const { data: profile } = useGetUpdateActivityCalendarProfileSuspense({
    profileId: profileId!,
  })
  const { mutateAsync: updateActivityCalendar } =
    useUpdateActivityWebCalendarProfile({
      mutation: {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: getGetApiWebCalendarGetProfilesQueryKey(),
          })
          queryClient.invalidateQueries({
            queryKey: getGetUpdateActivityCalendarProfileQueryKey({
              profileId: profileId!,
            }),
          })
          onClose()
        },
        onError: showErrorNotification,
      },
    })

  const handleSubmit = async (data: ActivityCalendarFormValues) => {
    await updateActivityCalendar({
      data: { ...data, webCalendarProfileId: profileId! },
    })
  }

  return (
    <ActivityCalendarForm
      onClose={onClose}
      handleSubmit={handleSubmit}
      initialValues={{ ...profile }}
    />
  )
}

interface Props extends ModalProps {
  profileId: number | undefined
}

export function UpdateActivityCalendarModal({ profileId, ...props }: Props) {
  const { t } = useTranslation("app_server")
  return (
    <DefaultModal
      title={t("Calendar_Subscriptions_UpdateActivityCalendar")}
      {...props}
    >
      {profileId && <ModalContent profileId={profileId} {...props} />}
    </DefaultModal>
  )
}
